import axios from "axios";
import consts from "../consts";
import { setErroAPI, setError, setSuccess } from "../common/toast/toast";
import { initialize } from "redux-form";
import confirmDialog from "../common/dialog/confirmDialog";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import FormatUtils from "../common/formatUtils/FormatUtils";

export function setModoTela(modo, registro = {}) {
    return {
        type: "CONTRATO_MERCADO_LIVRE_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setAguardando(aguardando) {
    return {
        type: "CONTRATO_MERCADO_LIVRE_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export async function buscarArquivo(registro) {
    try {
        const resp = await axios.get(`${consts.API_URL}/contratoMercadoLivre/buscarArquivo?id=${registro.id}`);
        const arquivo_contrato = resp.data.arquivo_contrato;
        return arquivo_contrato;
    } catch (e) {
        setError("Não foi possível buscar o arquivo do contrato");
    }
}

export function initForm(registro = {}) {
    registro.anos = (registro.anos || []).map((item) => ({
        id: item.id,
        ano: parseInt(item.ano),
        valor_contratado_anual: FormatUtils.formatarValorTela(item.valor_contratado_anual, 2),
        quantidade_energia_contratada_mensal: FormatUtils.formatarValorTela(item.quantidade_energia_contratada_mensal, 2),
        flexibilidade_minima: FormatUtils.formatarValorTela(item.flexibilidade_minima, 2),
        flexibilidade_maxima: FormatUtils.formatarValorTela(item.flexibilidade_maxima, 2),
    }));
    return [initialize("contratoMercadoLivreForm", registro)];
}

export function setFiltro(filtro) {
    return {
        type: "CONTRATO_MERCADO_LIVRE_FILTRO",
        payload: filtro,
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : getState().contratoMercadoLivre.filtro.id_cliente;

            const idUc = getState().contratoMercadoLivre.filtro.id_unidade_consumidora;

            dispatch(setAguardando(true));
            const resp = await axios.get(
                `${consts.API_URL}/contratoMercadoLivre?id_cliente=${idCliente}&id_unidade_consumidora=${idUc}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "CONTRATO_MERCADO_LIVRE_LISTADO",
                payload: resp,
            });
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
        if (!registro.id) {
            const registroFormatado = {
                ...registro,
                anos: registro.anos.map((registroAno) => ({
                    ano: parseInt(registroAno.ano),
                    valor_contratado_anual: FormatUtils.formatarValorBanco(registroAno.valor_contratado_anual, 2),
                    quantidade_energia_contratada_mensal: FormatUtils.formatarValorBanco(registroAno.quantidade_energia_contratada_mensal, 2),
                    flexibilidade_minima: FormatUtils.formatarValorBanco(registroAno.flexibilidade_minima, 2),
                    flexibilidade_maxima: FormatUtils.formatarValorBanco(registroAno.flexibilidade_maxima, 2),
                })),
            };
            dispatch(setAguardando(true));

            axios
                .post(`${consts.API_URL}/contratoMercadoLivre`, {
                    ...registroFormatado,
                    id_usuario_inclusao: getState().auth.usuario.id,
                })
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(
                        initForm({
                            ...registro,
                            id: resp.data.id,
                        })
                    );
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                    dispatch(setAguardando(false));
                })
                .catch((e) => {
                    setErroAPI(e);
                    dispatch(setAguardando(false));
                });
        } else {
            confirmDialog("Deseja realmente alterar?", () => {
                dispatch(setAguardando(true));

                axios
                    .put(`${consts.API_URL}/contratoMercadoLivre`, {
                        ...registro,
                        id_usuario_alteracao: getState().auth.usuario.id,
                    })
                    .then((resp) => {
                        setSuccess("Operação Realizada com sucesso.");
                        dispatch(getLista());
                        dispatch(setModoTela("lista"));
                        dispatch(setAguardando(false));
                    })
                    .catch((e) => {
                        setErroAPI(e);
                        dispatch(setAguardando(false));
                    });
            });
        }
    };
}

export function alterarContratoMercadoLivreAno(registro, callback) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente alterar?", async () => {
            dispatch(setAguardando(true));

            try {
                const registroFormatado = {
                    ...registro,
                    ano: parseInt(registro.ano),
                    valor_contratado_anual: FormatUtils.formatarValorBanco(registro.valor_contratado_anual, 2),
                    quantidade_energia_contratada_mensal: FormatUtils.formatarValorBanco(registro.quantidade_energia_contratada_mensal, 2),
                    flexibilidade_minima: FormatUtils.formatarValorBanco(registro.flexibilidade_minima, 2),
                    flexibilidade_maxima: FormatUtils.formatarValorBanco(registro.flexibilidade_maxima, 2),
                };
                await axios.put(`${consts.API_URL}/contratoMercadoLivreAno`, {
                    ...registroFormatado,
                    id_usuario_alteracao: getState().auth.usuario.id,
                });
                setSuccess("Operação Realizada com sucesso.");
                if (callback) callback();
            } catch (e) {
                setErroAPI(e);
            } finally {
                dispatch(setAguardando(false));
            }
        });
    };
}

export function visualizarArquivo(id, nomePdf) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const arquivo_contrato = await buscarArquivo({ id });
            dispatch(setArquivoPDF(arquivo_contrato, nomePdf));
        } catch (e) {
            setErroAPI(e);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        confirmDialog("Deseja realmente excluir?", () => {
            axios
                .delete(`${consts.API_URL}/contratoMercadoLivre?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
                .then((resp) => {
                    setSuccess("Operação Realizada com sucesso.");
                    dispatch(getLista());
                    dispatch(setModoTela("lista"));
                })
                .catch((e) => {
                    setErroAPI(e);
                });
        });
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONTRATO_MERCADO_LIVRE_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "CONTRATO_MERCADO_LIVRE_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function buscarPdfContrato({ id, nome }) {
    return async (dispatch, getState) => {
        try {
            const resp = await axios.get(`${consts.API_URL}/contratoMercadoLivre/buscarPdfContrato?id=${id}`);
            if (resp.data && resp.data.arquivo1) {
                let base64 = resp.data.arquivo1;
                const indiceInicioExtensao = base64.indexOf("/") + 1;
                const indiceFimExtensao = base64.indexOf(";");
                const extensao = base64.substring(indiceInicioExtensao, indiceFimExtensao);

                dispatch(setArquivoPDF(resp.data.arquivo1, `${nome}.${extensao}`, "landscape"));
            }
        } catch (ex) {
            setErroAPI(ex);
        }
    };
}
